<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 
<vue-snotify/>

<div class="columns box is-multiline is-centered">
<div class="column has-background-light" :class="return_column_width('is-12','is-12')">


<div class="columns is-gapless has-text-weight-bold has-text-white" style="margin-top:-1em;margin-bottom:.4em;">
 
<div class="column is-2"><a @click="get_staff_filter('*')" :class="{active: displayType === '*' }"  class="button is-fullwidth"><span class="icon is-small"> <i class="fas fa-sort-alpha-down"></i> </span> <span>ALL</span></a> </div>
<div class="column is-2"><a @click="get_staff_filter('ADMIN')" :class="{active: displayType === 'ADMIN' }"  class="button is-fullwidth"><span class="icon is-small"> <i class="fas fa-user-shield"></i> </span> <span>ADMIN</span></a> </div>
<div class="column is-2"><a @click="get_staff_filter('OFFICE')" :class="{active: displayType === 'OFFICE' }"  class="button is-fullwidth"><span class="icon is-small"> <i class="fas fa-user"></i> </span> <span>OFFICE</span></a> </div>
<div class="column is-2"><a @click="get_staff_filter('PROF')" :class="{active: displayType === 'PROF' }"  class="button is-fullwidth"><span class="icon is-small"> <i class="fas fa-chalkboard-teacher"></i> </span> <span>PROF</span></a> </div>

     <!-- <div @click="get_staff_filter('*')" class="column isLink has-text-info colBorder is-2 is-size-7 has-text-weight-bold has-text-centered">ALL</div> 
     <div @click="get_staff_filter('ADMIN')" class="column isLink has-text-info colBorder is-2 is-size-7 has-text-weight-bold has-text-centered">ADMIN</div> 
     <div @click="get_staff_filter('OFFICE')" class="column isLink has-text-info colBorder is-2 is-size-7 has-text-weight-bold has-text-centered">OFFICE</div> 
     <div @click="get_staff_filter('PROF')" class="column isLink has-text-info colBorder is-2 is-size-7 has-text-weight-bold has-text-centered">PROF</div>  -->

    <div class="column is-3"></div>

    <div class="column is-1">
        <button @click="staff_new()" class="button is-fullwidth has-background-success has-text-white">
            <span class="icon"><i class="fas fa-plus"></i></span>     
        </button> 
    </div>

</div>


<div class="columns is-gapless has-background-grey-dark has-text-light" style="margin-bottom:0em;">
     <div class="column colBorder is-3 is-size-7">&nbsp;&nbsp;NOM</div> 
     <div class="column colBorder is-4 is-size-7">&nbsp;&nbsp;LOGIN / EMAIL </div> 
     <div class="column colBorder is-2 is-size-7">&nbsp;&nbsp;CELL PHONE </div> 
</div>

<!-- &nbsp;&nbsp; {{data.staff_Nom}}, {{data.staff_Prenom}} -->

<div class="columns colBorder is-gapless" v-for="(data,index) in data_staff_display" :key="index" style="margin-bottom:.8em; border-bottom:2px solid gray">

<div class="column colBorder is-4">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="staff_changed(index)" v-model="data_staff_display[index].staff_Nom" placeholder="Prenom" class="input is-fullwidth"> 
    </div>  
    <div class="column is-12  is-size-6" style="margin-bottom:-.2em;">   
        <input @keyup="staff_changed(index)" v-model="data_staff_display[index].staff_Prenom" placeholder="Nom" class="input is-fullwidth"> 
    </div>



    <!-- <div class="column is-12 has-text-weight-bold has-text-danger is-size-7">&nbsp;&nbsp; {{data.staff_Type}} </div>  -->
</div>
</div><!-- END NAME  -->

<div class="column  is-4">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 is-size-6" style="margin-bottom:-.2em;"> 
      <input @keyup="staff_changed(index)" v-model="data_staff_display[index].staff_Email" placeholder="email" class="input is-fullwidth">
    </div>

    <div class="column is-6 is-size-6" style="margin-bottom:-.2em;"> 
      <input @keyup="staff_changed(index)" v-mask="'(###) ###-####'" v-model="data_staff_display[index].staff_TelOther" placeholder="cell #" class="input is-fullwidth">
    </div>

    <div class="column is-6 is-size-6" style="margin-bottom:-.2em;">
      <div class="select has-text-weight-bold is-fullwidth">
        <select @change="staff_changed(index)" v-model="data_staff_display[index].staff_Type" class="has-text-danger"><option>ADMIN</option><option>OFFICE</option><option>PROF</option></select>
      </div>
    </div>


</div>
</div><!-- END EMAIL  -->

<div class="column colBorder is-4">
<div class="columns is-gapless is-multiline">
    <div class="column has-text-centered is-6 has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
      <button @click="password_change_confirm(index)" class="button is-fullwidth"><span class="icon is-small has-text-grey"> <i class="fas fa-lock"></i> </span>&nbsp;&nbsp;&nbsp;Reset Pass</button>
    </div> 

    <div class="column has-text-centered is-6 has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
      <button @click="staff_delete_confirm(index)" class="button is-fullwidth"><span class="icon is-small has-text-grey"> <i class="fas fa-trash-alt"></i> </span>&nbsp;&nbsp;&nbsp;Delete</button>
    </div>  

 <!-- STAFF SAVE  -->
    <div v-if="+data_staff_display[index].isChanged" class="column has-text-centered is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> 
      <button @click="staff_save(index)" class="button is-success is-fullwidth"><span class="icon is-small has-text-white"> <i class="fas fa-save"></i> </span>&nbsp;&nbsp;&nbsp;SAVE</button>
    </div>

<!-- STAFF DELETE  -->
<div v-else-if="+data_staff_display[index].doDelete" class="column has-text-centered is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> 
      <div class="columns is-gapless">
          <div class="column colBorder is-4">
                <button @click="staff_delete_cancel(index)" class="button has-text-danger is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-danger fas fa-window-close"></i> </span>&nbsp;&nbsp;&nbsp;CANCEL</button>
          </div>
          <div class="column colBorder is-8">
                <button @click="staff_delete_execute(index)" class="button has-text-success is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-success fas fa-check-circle"></i> </span>&nbsp;&nbsp;&nbsp;DELETE</button>
          </div>
      </div>
</div>

<!-- STAFF PASSWORD  -->
<div v-else-if="+data_staff_display[index].passChange" class="column has-text-centered is-12  is-size-6" style="margin-bottom:-.2em;"> 
      <div class="columns is-vcentered is-gapless">

<div class="column has-text-weight-bold has-background-warning is-3  has-text-centered has-text-dark"> {{data_staff_display[index].passNew}} </div> 

          <div class="column colBorder is-2">
                <button @click="password_change_cancel(index)" class="button has-text-danger is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-danger fas fa-window-close"></i> </span></button>
          </div>

          <div class="column colBorder is-2">
                <button @click="password_save(index, false)" class="button has-text-success is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-success fas fa-save"></i> </span></button>
          </div>

          <div class="column colBorder is-5">
                <button @click="password_save(index,true)" class="button has-text-success is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-success fas fa-save"></i> </span> + <span class="icon is-small has-text-grey"> <i class=" has-text-success fas fa-paper-plane"></i> </span></button>
          </div>


      </div>
</div>



</div>
</div><!-- END CELL  -->



</div>

</div></div> <!-- END CONTAINER COLUMN  -->
</div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AdminStaff',
  props: [ ],

    data() {
        return {
            isLoading:false,
            data_staff:[],
            data_staff_display:[],
            view_type:'ALL',
            displayType:'*',
        }
    },

created() {
  this.get_staff_list() 
},


methods: {

staff_new:function() {

// CHECK IF ALREADY ONE NEW
if (this.data_staff_display[0].staff_ID == 0) {return;}

  this.data_staff_display.unshift(
    {staff_ID:0, isChanged:0,staff_Nom:'',staff_Prenom:'',staff_Email:'',staff_TelOther:'',staff_Type:'', doDelete:0, passChange:0, passNew:'' }
  )
},

staff_delete_confirm:function(index) {
  this.data_staff_display[index].passChange = false 
  this.data_staff_display[index].doDelete = true 
},
staff_delete_execute:function(index) {

// CHECK IF NOT SAVED
if (this.data_staff_display[index].staff_ID == 0) {this.data_staff_display.splice(index,1); return;}

// REMOVE FROM DB
var query = "DELETE FROM myMEQ_STAFF WHERE staff_ID = " + this.data_staff_display[index].staff_ID
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    this.data_staff_display.splice(index,1)
});
 
},
staff_delete_cancel:function(index) {
  this.data_staff_display[index].doDelete = false
},

password_change_confirm:function(index) {
  this.data_staff_display[index].passNew = this.makeid(5)
  this.data_staff_display[index].passChange = true 
  this.data_staff_display[index].doDelete = false
},
password_change_cancel:function(index) {
  this.data_staff_display[index].passNew = ''
  this.data_staff_display[index].passChange = false 
},
password_save:function(index,doSend) {

  if (doSend){ // CHECK PHONE
    if (this.data_staff_display[index].staff_TelOther == '') 
    {this.$snotify.error('ENTER CELL!' , {timeout: 2000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",}); return; }

    var phoneno = /^(\([0-9]{3}\)\s*|[0-9]{3}\-)[0-9]{3}-[0-9]{4}$/; 
    if(!this.data_staff_display[index].staff_TelOther.match(phoneno))
    {this.$snotify.error('INVALID CELL!' , {timeout: 2000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",}); return; }
  }

      var query = "UPDATE myMEQ_STAFF SET "
      query += "staff_PASSWORD = '" + this.data_staff_display[index].passNew
      query += "' WHERE staff_ID = " + this.data_staff_display[index].staff_ID
      axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
      .then(res => { 
          if (doSend) {
             axios.post(this.$url+'/sms_send?msg=Votre Password : ' + this.data_staff_display[index].passNew +  ' mymeq.ca &to='+this.data_staff_display[index].staff_TelOther)
            .then(res => { this.$snotify.success('SAVED & SENT!!' , {timeout: 2000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",}); })
          } else {
            this.$snotify.success('SAVED!!' , {timeout: 2000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
            this.data_staff_display[index].passChange = false
          }
      });

},




staff_save:function(index) {
  this.data_staff_display[index].doDelete = false
  this.data_staff_display[index].passChange = false

  if (this.data_staff_display[index].staff_Nom == '') 
  {this.$snotify.error('ENTER NAME!' , {timeout: 2000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",}); return; }

  if (this.data_staff_display[index].staff_Type == '') 
  {this.$snotify.error('ENTER LEVEL!' , {timeout: 2000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",}); return; }

var isNEW = false 
var query = ''
if (this.data_staff_display[index].staff_ID == 0) // NEW
{ 
  isNEW = true
  query = "INSERT INTO myMEQ_STAFF (staff_Nom,staff_blnAgenda) VALUES ('" + this.data_staff_display[index].staff_Nom.replace(/'/g,"''") + "',0)" 
  query += ";SELECT MAX(staff_ID) AS newID FROM myMEQ_STAFF"
  console.log(query)
  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
      this.data_staff_display[index].staff_ID = res.data[0].newID

      query = "UPDATE myMEQ_STAFF SET "
      query += "staff_Nom = '" + this.chk_val(this.data_staff_display[index].staff_Nom)
      query += "',staff_Prenom = '" + this.chk_val(this.data_staff_display[index].staff_Prenom)
      query += "',staff_Email = '" + this.chk_val(this.data_staff_display[index].staff_Email)
      query += "',staff_TelOther = '" + this.chk_val(this.data_staff_display[index].staff_TelOther)
      query += "',staff_Type = '" + this.chk_val(this.data_staff_display[index].staff_Type)
      query += "' WHERE staff_ID = " + this.data_staff_display[index].staff_ID
      axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
      .then(res => { 
          this.$snotify.success('SAVED!!' , {timeout: 2000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
          this.data_staff_display[index].isChanged = false
          if (isNEW) {this.password_change_confirm(0)}
      });
  });
} // END ADDING NEW
else 
{ // UPDATE
      query = "UPDATE myMEQ_STAFF SET "
      query += "staff_Nom = '" + this.chk_val(this.data_staff_display[index].staff_Nom)
      query += "',staff_Prenom = '" + this.chk_val(this.data_staff_display[index].staff_Prenom)
      query += "',staff_Email = '" + this.chk_val(this.data_staff_display[index].staff_Email)
      query += "',staff_TelOther = '" + this.chk_val(this.data_staff_display[index].staff_TelOther)
      query += "',staff_Type = '" + this.chk_val(this.data_staff_display[index].staff_Type)
      query += "' WHERE staff_ID = " + this.data_staff_display[index].staff_ID
      axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
      .then(res => { 
          this.$snotify.success('SAVED!!' , {timeout: 2000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
          this.data_staff_display[index].isChanged = false
      });


}


  
},

staff_changed:function(index) {
  this.data_staff_display[index].isChanged = true
},


get_staff_list:function() {
  var query =  "SELECT *, 0 as isChanged, 0 as doDelete, 0 as passChange, '' as passNew FROM MyMEQ_STAFF ORDER BY staff_Nom"
  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))  
  .then(res => { this.data_staff = res.data ; this.data_staff_display = res.data });
},
get_staff_filter:function(type) {
// FILTER  
  this.data_staff_display = []
  this.displayType = type; // FOR BUTTON ACTIVE
  if (type == '*') { this.data_staff_display = this.data_staff ; return }

  var self = this;
  this.data_staff.forEach(function(data){
      if (data.staff_Type == type) {self.data_staff_display.push(data)}
  });

},

chk_val:function(val) {
  if (val) {return val.replace(/'/g,"''")}
  else {return ''}

},


check_mobile() {
// RETURN COLLEGE NAME - SHORT FOR MOBILE
if (sessionStorage.getItem('isMobile') == 'true')
  {return true}
  else {return false}
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return sizeM} else {return sizeD} 
},
makeid:function(length) {
   var result           = '';
   var characters       = 'AB0123456789';
   var charactersLength = characters.length;
   for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
},


}

}
</script>

<style scoped>

.active{
  background-color:LIGHTCYAN;
}

</style>
